import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EvenementWebhook } from 'src/api/models';

@Component({
  selector: 'app-webhook-evenement-select',
  templateUrl: './webhook-evenement-select.component.html',
  styleUrls: ['./webhook-evenement-select.component.css']
})
export class WebhookEvenementSelectComponent implements OnInit {

  @Input('id') public id: number;
  @Output() idChange = new EventEmitter<number>();

  @Input() cell: any;

  webhookEvenements = [];
  
  constructor() {     
    for (var e in EvenementWebhook) {
      let value = parseInt(e, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.webhookEvenements.push({ id: value, name: EvenementWebhook[e]});
      }
    }    
  }

  ngOnInit(): void {
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }
}
